<!-- quotation-doc -->
<div class="common-popup-container document-popup-wrapper">
	<img src="assets/images/white-close.svg" (click)="closeModal()" alt="" class="close close-doc">

	<div class="doc-pdf-container">
		<div class="requiring-doc-container doc-header-container">
			<div class="column quotation-column align-items-start">

				<img src="assets/images/sign-doc.svg" alt="">

				<div class="ml-2">

					<!-- 🔹 Quotation ID + bookingNo + serviceType -->
					<div class="d-flex align-items-center">
						<h3 class="title mb-0">Quotation : #{{ data.quotationId }}</h3>

						<!-- Show only first 2 booking numbers -->
						<ng-container *ngFor="let item of data.bookingData | slice:0:2">
							<span class="highlight-badge badge-item ml-2">
								<img [src]="data?.uploadedByImage || 'assets/images/new-set/light/default-profile.svg'"
									class="user-icon" alt="" />
								#{{ item.bookingNo }}
							</span>
						</ng-container>

						<!-- Show "+(count) more" if bookingData has more than 2 items -->
						<span *ngIf="data.bookingData?.length > 2" class="highlight-badge badge-item ml-2">
							+{{ data.bookingData.length - 2 }} more
						</span>

						<!-- First service type -->
						<span class="highlight-badge badge-item ml-1" *ngIf="data.bookingData?.length">
							<img src="assets/images/new-set/light/inspection-navigation.svg" class="badge-icon" alt="">
							{{ data.bookingData[0].serviceType }}
						</span>
					</div>


					<!-- 🔹 Uploaded by & Uploaded date -->
					<div class="d-flex align-items-center mt-2">
						<div class="uploaded-by-container">
							<p class="heading">{{ 'QUOTATIONNEW_SUMMARY.LBL_UPLOADED' | translate }}:</p>

							<div class="d-flex align-items-center" style="flex-wrap: nowrap;">
								<div class="d-flex align-items-center">
									<img [src]="data.uploadedByImage || 'assets/images/new-set/light/default-profile.svg'"
										class="user-icon" alt="" />
									<span class="description ml-1">{{ data.uploadedBy
    ? (data.uploadedBy.length > 20
        ? (data.uploadedBy | slice:0:20) + '...'
        : data.uploadedBy)
    : ''
}}</span>
								</div>
							</div>
				<div class="align-items-center" style="flex-wrap: nowrap;">
										<span class="uploaded-date mb-0 ml-1" *ngIf="data.uploadedOn">on {{ data.uploadedOn | date: 'dd MMM yyyy' }}</span>
				</div>

							<!-- Optional description if needed -->
							<p class="description">
  {{ data.comment | slice:0:20 }}
  <span *ngIf="data.comment?.length > 20">...</span>

  <a *ngIf="data.comment?.length > 20"
     href="javascript:void(0)"
     class="more-link"
     data-bs-toggle="tooltip"
     data-bs-placement="top"
     [attr.title]="data.comment">
     More
  </a>
</p>
						</div>

						<!-- 🔹 APPROVED -->
						<div class="uploaded-by-container" *ngIf="data.statusId == 3">
							<p class="heading green_text"  style="cursor: pointer;">{{ 'QUOTATIONNEW_SUMMARY.LBL_APPROVED' | translate }} :</p>

							<div class="d-flex align-items-center" style="flex-wrap: nowrap;">
								<img [src]="data?.uploadedByImage || 'assets/images/new-set/light/default-profile.svg'"
									class="user-icon" alt="" />
								<span class="description ml-1">{{ data.uploadedBy
    ? (data.uploadedBy.length > 20
        ? (data.uploadedBy | slice:0:20) + '...'
        : data.uploadedBy)
    : ''
}}</span>
								<!-- <span class="uploaded-date mb-0 ml-1">on {{ data.uploadedOn | date: 'dd MMM yyyy' }}</span> -->
							</div>
						
							<div class="align-items-center" style="flex-wrap: nowrap;">
										<span class="uploaded-date mb-0 ml-1" *ngIf="data.uploadedOn">on {{ data.uploadedOn | date: 'dd MMM yyyy' }}</span>
				</div>



							<p class="description">
  {{ data.approvedComment | slice:0:20 }}
  <span *ngIf="data.approvedComment?.length > 20">...</span>

  <a *ngIf="data.approvedComment?.length > 20"
     href="javascript:void(0)"
     class="more-link"
     data-bs-toggle="tooltip"
     data-bs-placement="top"
     [attr.title]="data.approvedComment">
     More
  </a>
</p>


						</div>

						<!-- 🔹 REJECTED -->
						<div class="uploaded-by-container" *ngIf="data.statusId == 2">
							<p class="heading red_text">{{ 'QUOTATIONNEW_SUMMARY.LBL_REJECTED' | translate }} :</p>

							<div class="d-flex align-items-center" style="flex-wrap: nowrap;">
								<img [src]="data?.uploadedByImage || 'assets/images/new-set/light/default-profile.svg'"
									class="user-icon" alt="" />
								<span class="description ml-1">{{ data.uploadedBy }}</span>
								<!-- <span class="uploaded-date mb-0 ml-1">on {{ data.uploadedOn | date: 'dd MMM yyyy' }}</span> -->
							</div>


							<div class="align-items-center" style="flex-wrap: nowrap;">
										<span class="uploaded-date mb-0 ml-1" *ngIf="data.uploadedOn">on {{ data.uploadedOn | date: 'dd MMM yyyy' }}</span>
				</div>

						<p class="description">
  {{ data.approvedComment | slice:0:20 }}
  <span *ngIf="data.approvedComment?.length > 20">...</span>

  <a *ngIf="data.approvedComment?.length > 20"
     href="javascript:void(0)"
     class="more-link"
     data-bs-toggle="tooltip"
     data-bs-placement="top"
     [attr.title]="data.approvedComment">
     More
  </a>
</p>
						</div>
					</div>

				</div>
			</div>

			<!-- RIGHT SIDE BUTTON AREA -->
			<div class="column">

				<!-- 🔹 Status-based UI -->

				<!-- Approved -->
				<div class="d-flex" *ngIf="data.statusId == 3 ">
					<div class="result-status-wrapper inline pass-container x-large" >
						<img src="assets/images/thick-pass-icon.svg" alt="" class="icon">
						<p class="result-status pass text" >{{ 'QUOTATIONNEW_SUMMARY.LBL_APPROVED' | translate }}</p>
					</div>
				</div>

				<!-- Rejected -->
				<div class="d-flex" *ngIf="data.statusId == 2" >
					<button class="secondary-cta big mr-2" (click)="triggerReuploadFileInput(fileInput2)">
						<img src="assets/images/thick-upload.svg" class="mr-2"
							(click)="triggerReuploadFileInput(fileInput2)"> {{ 'QUOTATIONNEW_SUMMARY.LBL_RE_UPLOAD'
						| translate }}
					</button>

					<input #fileInput2 type="file" (change)="onFileSelectedForReupload($event , quItem)" hidden>
					<div class="result-status-wrapper inline rejected-container x-large" >
						<img src="assets/images/thick-fail-icon.svg" alt="" class="icon">
						<p class="result-status fail text">{{ 'QUOTATIONNEW_SUMMARY.LBL_REJECTED' | translate }}</p>
					</div>
				</div>

				<!-- Pending -->
				<div class="d-flex" *ngIf="data.statusId == 1 ">
					<button class="tertiary-cta big mr-2" (click)="downloadQuotation(data.quotationFileUrl)">
						<img src="assets/images/thick-download-icon.svg" class="mr-2" alt="export">
						{{ 'QUOTATIONNEW_SUMMARY.LBL_DOWNLOAD' | translate }}
					</button>
					<button class="secondary-cta rejected-cta mr-2"  (click)="rejectPopup()" 
					        *ngIf="_IsCustomerUser && data.isContactTypeAdded">
						<img src="assets/images/thick-fail-icon.svg" alt="" style="cursor: pointer;">
						{{ 'QUOTATIONNEW_SUMMARY.LBL_REJECT' | translate }}
					</button>

					<div class="result-status-wrapper inline pass-container x-large"  style="cursor: pointer;" (click)="acceptDesign()"
						*ngIf="_IsCustomerUser && data.isContactTypeAdded">
						<img src="assets/images/thick-pass-icon.svg" alt="" class="icon"  style="cursor: pointer;">
						<p class="result-status pass text"  style="cursor: pointer;">{{ 'QUOTATIONNEW_SUMMARY.LBL_APPROVE' | translate }}</p>
					</div>
				</div>
			</div>
		</div>

		<!-- PDF DOCUMENT -->
		<div class="doc-body-container">
			<iframe [src]="iframeUrl" frameborder="0" width="100%" height="814px" class="pdf-doc"></iframe>
		</div>
	</div>
</div>